import { render, staticRenderFns } from "./LogisticTimeLine.vue?vue&type=template&id=28217842&scoped=true"
import script from "./LogisticTimeLine.vue?vue&type=script&lang=js"
export * from "./LogisticTimeLine.vue?vue&type=script&lang=js"
import style0 from "./LogisticTimeLine.vue?vue&type=style&index=0&id=28217842&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28217842",
  null
  
)

export default component.exports